import { render, staticRenderFns } from "./NewDSelectEditor.vue?vue&type=template&id=a1511460&"
import script from "./NewDSelectEditor.vue?vue&type=script&lang=js&"
export * from "./NewDSelectEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDSelectEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports